module.exports = __webpack_public_path__ + "static/media/appicon.532e37fa.png";